//
//

import { date, uid } from "quasar";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { setPluginIconColor } from "@/assets/js/appFunc";
import PISideBarFilters from "@/components/Admin/ProcessInspector/PISideBarFilters.vue";
import PIDataTable from "@/components/Admin/ProcessInspector/PIDataTable.vue";

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { APP_DATE_SLASH, APP_DATETIME_SLASH } from "@/assets/js/appConfig";
import NestedDraggable from "../config/subcomponents/NestedDragable.vue";
import {
    getNestedValuesObj,
    formatDateAndTime,
    deepCopy,
    getConcatLabel
} from "../config/set-conditions";
import AQInput from "../../Generics/AQInput/AQInput.vue";
import AQDatetime from "../../Generics/AQDatetime/AQDatetime.vue";

const paste = require("@/assets/images/Paste-Icon.svg");

export default {
    name: "RuleTesting",
    components: {
        NestedDraggable,
        PISideBarFilters,
        PIDataTable,
        AQInput,
        AQDatetime,
        AQButton,
        AQTooltip,
        AQBadge
    },
    data() {
        return {
            scrollContainer: null,
            payloadStatements: [],
            found: false,
            payloadToTest: [],
            itemConditionsArray: [],
            dateModel: {},
            inputComponent: 0,
            instanceAppName: "",
            instanceId: "",
            instanceIsOpened: false,
            mode: "b",
            payloadToSend: {},
            objectToSend: {},
            payloadConditions: [],
            testAgainLabel: false,
            nestedChevronUp: false,
            chevronUp: null,
            ruleResultArray: [],
            itemsResults: null,
            itemReferenceValue: {},
            stack: "",
            statement: "",
            inputModel: {},
            copyOfInputModel: {},
            conditionsObj: {},
            pasteIcon: paste,
            testingRules: [],
            searchData: "",
            searchingAction: false,
            appToSelect: {}
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("version", ["latestVersionId"]),
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        ...mapGetters("rules", [
            "getCurrentRule",
            "getCurrentLevel",
            "getTestedRules",
            "showInstanceTable",
            "getSelectedCondition"
        ]),
        pluginIconColor() {
            return setPluginIconColor(this.selectedPluginConfigData.pluginType);
        },
        computedRules() {
            let ruleList = [];
            const levels = [
                {
                    uuid: uid(),
                    name: "",
                    index: 0,
                    rules: []
                }
            ];
            // one level selected
            if (
                Object.entries(this.getCurrentLevel).length
                && !Object.entries(this.getCurrentRule).length
            ) {
                ruleList.push(this.getCurrentLevel);
            } else if (Object.entries(this.getCurrentRule).length) { // one rule selected from task or matrix
                levels[0].rules.push(this.getCurrentRule);
                ruleList.push(levels[0]);
                // all levels selected from matrix
            } else if (
                this.selectedPluginConfigData.pluginType === "APPROVAL_PLUGIN"
            ) {
                ruleList = this.selectedPluginConfigData.levels;
                // for task plugin
            } else if (
                this.selectedPluginConfigData.pluginType === "TASK_PLUGIN"
            ) {
                // all task rule selected push 1 random element for v-for (used only for iterate in this case)
                if (
                    (!this.selectedPluginConfigData.levels
                    || !this.selectedPluginConfigData.levels.length)
                    && this.selectedPluginConfigData.rules
                    && this.selectedPluginConfigData.rules.length
                ) {
                    levels[0].rules = this.selectedPluginConfigData.rules;
                    // ruleList.push("one element used for iterate in this case");
                    ruleList.push(levels[0]);
                } else if (
                    this.selectedPluginConfigData.levels
                    && Object.entries(this.getCurrentLevel).length
                ) {
                    levels[0].rules = this.getCurrentLevel.rules;
                    ruleList.push(levels[0]);
                }
            }
            return this.nestedComputedRules(deepCopy(ruleList).clone);
        }
    },
    watch: {
        getSelectedCondition: {
            handler(newInputRef) {
                if (newInputRef) {
                    const inputContainer = document.getElementById(newInputRef);
                    if (this.isScrollable(this.scrollContainer)) {
                        this.afterScroll(newInputRef, inputContainer);
                    } else {
                        this.applyFocus(newInputRef, inputContainer);
                    }
                }
            }
        },
        getTestedRules: {
            handler(newVal) {
                if (newVal && Array.isArray(newVal)) {
                    this.ruleResultArray = newVal;
                    if (!this.testAgainLabel) {
                        this.testAgainLabel = true;
                    }
                } else {
                    this.ruleResultArray = [];
                }
            }
        }
    },
    mounted() {
        this.scrollContainer = document.getElementById(
            "side-bar-input-container"
        );
        this.sideBarInput();
        this.$forceUpdate();
    },
    beforeDestroy() {
        this.$store.commit("rules/setShowRuleTesting", false);
    },
    methods: {
        ...mapActions("rules", ["testRule", "instanceVariablesValues"]),
        ...mapMutations("rules", [
            "setShowRuleTesting",
            "setShowInstanceTable",
            "testedRules"
        ]),
        getConcatLabel,
        setFormat(type) {
            let format;
            if (type === "time") {
                format = "HH:mm";
            } else if (type === "date") {
                format = APP_DATE_SLASH;
            } else {
                format = APP_DATETIME_SLASH;
            }
            return format;
        },
        addTooltipAtBlur(refName) {
            if (this.$refs[refName]) {
                const inputElement = this.$refs[refName][0];
                if (!inputElement.isFocused) {
                    inputElement.$el.classList.remove(
                        "rule-testing-input-no-tooltip"
                    );
                    inputElement.$el.classList.add(
                        "rule-testing-input-tooltip"
                    );
                }
            }
        },
        removeTooltipAtClick(refName) {
            if (this.$refs[refName]) {
                const inputElement = this.$refs[refName][0];
                if (inputElement.isFocused) {
                    inputElement.$el.classList.remove(
                        "rule-testing-input-tooltip"
                    );
                    inputElement.$el.classList.add(
                        "rule-testing-input-no-tooltip"
                    );
                }
            }
        },
        // start methods for focus input
        isScrollable(element) {
            return (
                element.scrollWidth > element.clientWidth
                || element.scrollHeight > element.clientHeight
            );
        },
        isScrolledIntoView(el) {
            const rect = el.getBoundingClientRect();
            const elemTop = rect.top;
            const elemBottom = rect.bottom;

            const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
            return isVisible;
        },

        afterScroll(newInputRef, inputContainer) {
            this.scrollContainer.scrollTo({
                top: inputContainer.offsetTop - 450,
                left: 0,
                behavior: "smooth"
            });
            const checkIfScrolled = setInterval(() => {
                this.isScrolledIntoView(inputContainer);
                if (this.isScrolledIntoView(inputContainer)) {
                    clearInterval(checkIfScrolled);
                    this.applyFocus(newInputRef, inputContainer);
                }
            }, 100);
        },
        applyFocus(newInputRef) {
            if (this.$refs[newInputRef]) {
                if (
                    this.$refs[newInputRef][0].type
                    && (this.$refs[newInputRef][0].type === "time"
                    || this.$refs[newInputRef][0].type === "date"
                        || this.$refs[newInputRef][0].type === "datetime")
                ) {
                    if (this.$refs[newInputRef][0].$children) {
                        this.$refs[newInputRef][0].$children[0].show();
                    }
                } else if (this.$refs[newInputRef][0].$children) {
                    this.$refs[newInputRef][0].$children[0].focus();
                }
            }
        },
        searchForData(data) {
            this.searchData = data;
        },
        // end methods for focus input
        sendRuleResults(levelIndex, ruleIndex) {
            let result = [];
            if (
                this.ruleResultArray
                && this.ruleResultArray.length
                && this.ruleResultArray[levelIndex]
            ) {
                try {
                    result = this.ruleResultArray[levelIndex].rules[ruleIndex]
                        .conditions;
                } catch (err) {
                    console.error(err);
                }
            }
            return result;
        },
        // start methods for InstanceTable
        getInstanceForTest() {
            this.$store.commit("rules/setShowInstanceTable", true);
            this.appToSelect = this.currentApp;
        },
        openInstance(data) {
            this.$store.commit("rules/testedRules", null);
            const instanceDataToSend = {
                formulas: this.payloadStatements,
                processInstanceId: data.instanceId
            };
            this.instanceVariablesValues(instanceDataToSend).then(
                variablesData => {
                    if (variablesData) {
                        Object.keys(this.conditionsObj).forEach(key => {
                            this.inputModel[key] = variablesData[key] || "";
                            this.dateModel[key] = variablesData[key] || "";
                            this.setInputValue(
                                this.inputModel[key],
                                key,
                                this.conditionsObj[key]
                            );
                        });

                        this.$store.commit("rules/setShowInstanceTable", false);
                        this.instanceIsOpened = true;
                        this.instanceAppName = data.applicationName;
                        this.instanceId = data.instanceId;
                    }
                }
            );
        },
        applyFilterPayload(payloadToSend) {
            this.payloadToSend = payloadToSend;
        },
        setObjectToSend(data) {
            this.objectToSend = data;
        },
        // end methods for InstanceTable
        setNrOfLevels(isTask) {
            let nrOfLabels = "";
            if (isTask) {
                if (this.selectedPluginConfigData.rules.length > 1) {
                    nrOfLabels = `${this.selectedPluginConfigData.rules.length
                    } ${
                        this.$t("diagrams.components.ruleTesting.rules")}`;
                } else {
                    nrOfLabels = `${this.selectedPluginConfigData.rules.length
                    } ${
                        this.$t("diagrams.components.ruleTesting.rule")}`;
                }
            } else if (this.selectedPluginConfigData.levels) {
                if (this.selectedPluginConfigData.levels.length > 1) {
                    nrOfLabels = `${this.selectedPluginConfigData.levels.length
                    } ${
                        this.$t("diagrams.components.ruleTesting.levels")}`;
                } else {
                    nrOfLabels = `${this.selectedPluginConfigData.levels.length
                    } ${
                        this.$t("diagrams.components.ruleTesting.level")}`;
                }
            } else {
                nrOfLabels = `${1
                } ${
                    this.$t("diagrams.components.ruleTesting.level")}`;
            }
            return nrOfLabels;
        },
        forceRerender() {
            this.inputComponent += 1;
        },
        setInputValue(input, varName, type) {
            let inputValue = input;
            this.instanceIsOpened = false;
            if (inputValue === null) {
                inputValue = "";
                this.dateModel[varName] = inputValue;
            }
            let inputValueServer = inputValue;
            if (type === "time" || type === "datetime" || type === "date") {
                if (inputValue && type === "time" && !date.isValid(inputValue)) {
                    const [time] = inputValue.split("+");
                    inputValue = date.formatDate(`1970-01-01T${time}`, "YYYY-MM-DDTHH:mm:ss.SSSZ");
                    this.dateModel[varName] = time;
                } else {
                    this.dateModel[varName] = inputValue;
                }
                inputValueServer = formatDateAndTime(type, inputValue);
                inputValueServer = inputValueServer.replace(/\'/g, ""); //eslint-disable-line
                inputValue = formatDateAndTime(type, inputValue, true);
            }
            this.inputModel[varName] = inputValueServer;
            if (type === "time" || type === "date" || (type === "datetime" && !inputValue)) {
                this.forceRerender();
            }
            for (let i = 0; i < this.itemReferenceValue[varName].length; i++) {
                this.itemReferenceValue[varName][i].value = inputValue;
            }
        },
        closeTimeModal(type) {
            if (type === "datetime") {
                this.forceRerender();
            }
        },
        sideBarInput() {
            this.itemConditionsArray.forEach(level => {
                level.rules.forEach(rule => {
                    rule.conditions.conditions.forEach(condition => {
                        this.getAllVariables(condition);
                    });
                });
            });
        },
        getEvaluationClass(ruleIndex, levelIndex) {
            let result = "";
            if (
                this.ruleResultArray
                && this.ruleResultArray.length
                && this.ruleResultArray[levelIndex]
            ) {
                result = this.ruleResultArray[levelIndex].rules[ruleIndex]
                    .ruleResult;
            }
            return result;
        },
        getGroupsVariables(obj, stack) {
            const vm = this;
            Object.keys(obj).forEach(property => {
                if (obj.hasOwnProperty(property)) {
                    if (
                        property === "conditions"
                        || (obj[property] && obj[property].conditions)
                    ) {
                        this.getGroupsVariables(
                            obj[property],
                            `${stack}.${property}`
                        );
                    } else {
                        if (
                            obj[property]
                            && obj[property].type === "condition"
                            && (obj[property].val1.type === "MOD"
                                || obj[property].val1.type === "VAR")
                        ) {
                            vm.conditionsObj[obj[property].val1.value] = obj[property].val1.fieldType;
                            if (
                                !vm.itemReferenceValue[obj[property].val1.value]
                            ) {
                                vm.itemReferenceValue[
                                    obj[property].val1.value
                                ] = [];
                            }
                            vm.itemReferenceValue[
                                obj[property].val1.value
                            ].push(obj[property].val1);
                        }
                        if (
                            obj[property]
                            && obj[property].type === "condition"
                            && (obj[property].val2.type === "MOD"
                                || obj[property].val2.type === "VAR")
                        ) {
                            vm.conditionsObj[obj[property].val2.value] = obj[property].val2.fieldType;
                            if (
                                !vm.itemReferenceValue[obj[property].val2.value]
                            ) {
                                vm.itemReferenceValue[
                                    obj[property].val2.value
                                ] = [];
                            }
                            vm.itemReferenceValue[
                                obj[property].val2.value
                            ].push(obj[property].val2);
                        }
                    }
                }
            });
        },
        getAllVariables(condition) {
            const vm = this;
            if (condition.type === "condition") {
                if (
                    condition.val1.value
                    && (condition.val1.type === "MOD"
                        || condition.val1.type === "VAR")
                ) {
                    vm.conditionsObj[condition.val1.value] = condition.val1.fieldType;

                    if (!vm.itemReferenceValue[condition.val1.value]) {
                        vm.itemReferenceValue[condition.val1.value] = [];
                    }

                    vm.itemReferenceValue[condition.val1.value].push(
                        condition.val1
                    );
                }
                if (
                    condition.val2.value
                    && (condition.val2.type === "MOD"
                        || condition.val2.type === "VAR")
                ) {
                    vm.conditionsObj[condition.val2.value] = condition.val2.fieldType;

                    if (!vm.itemReferenceValue[condition.val2.value]) {
                        vm.itemReferenceValue[condition.val2.value] = [];
                    }
                    vm.itemReferenceValue[condition.val2.value].push(
                        condition.val2
                    );
                }
            } else if (condition.type === "group") {
                this.getGroupsVariables(condition, "");
            }
        },

        setRules(level) {
            if (this.payloadToTest.length) {
                for (let i = 0; i < this.payloadToTest.length; i++) {
                    if (this.payloadToTest[i].uuid === level.uuid) {
                        this.found = true;
                        break;
                    }
                }
            }
            if (!this.found) {
                this.payloadToTest.push(deepCopy(level).clone);
            }
            this.itemConditionsArray.push(level);
            return level.rules.map(rule => ({
                uuid: rule.uuid,
                name: rule.name,
                index: rule.index,
                conditions: {
                    statement: this.setStatement(rule),
                    itemCondition: {
                        type: "group",
                        logicOperatorAfter: null,
                        conditions: rule.conditions.conditions
                    }
                }
            }));
        },
        setStatement(rule) {
            if (
                !this.payloadStatements.length
                || (this.payloadStatements.length
                    && this.payloadStatements.indexOf(
                        rule.conditions.statement
                    ) === -1)
            ) {
                this.payloadStatements.push(rule.conditions.statement);
            }
            return rule.conditions.statement;
        },
        nestedComputedRules(ruleList) {
            const levels = ruleList.map(level => ({
                uuid: level.uuid || uid(),
                name: level.name || "",
                index: level.index || 0,
                rules: this.setRules(level)
            }));
            return levels;
        },
        conditionIcon(type, isType) {
            const conditionStyle = {};
            switch (type) {
                case "integer":
                    conditionStyle.type = "INT";
                    conditionStyle.bgColor = "background-color: #2E4B78";
                    break;
                case "boolean":
                    conditionStyle.type = "BOOL";
                    conditionStyle.bgColor = "background-color: #6F7681";
                    break;
                case "attachment":
                    conditionStyle.type = "ATT";
                    conditionStyle.bgColor = "background-color: #00B55B";
                    break;
                case "time":
                    conditionStyle.type = "TIME";
                    conditionStyle.bgColor = "background-color: #AF5200";
                    break;
                case "datetime":
                    conditionStyle.type = "DTM";
                    conditionStyle.bgColor = "background-color: #B53434";
                    break;
                case "date":
                    conditionStyle.type = "DATE";
                    conditionStyle.bgColor = "background-color: #C99915";
                    break;
                case "decimal":
                    conditionStyle.type = "DEC";
                    conditionStyle.bgColor = "background-color: #2E7875";
                    break;
                default:
                    conditionStyle.type = "STR";
                    conditionStyle.bgColor = "background-color: #2C3543";
            }
            return isType ? conditionStyle.type : conditionStyle.bgColor;
        },
        testRule() {
            const payload = {
                levels: []
            };
            this.payloadToTest.forEach(level => {
                payload.levels.push({
                    levelIndex: level.index,
                    rules: level.rules.map(rule => ({
                        conditions: rule.conditions.conditions,
                        ruleId: rule.uuid,
                        ruleResult: true
                    }))
                });
            });
            payload.versionId = this.latestVersionId;
            payload.applicationId = this.currentApp.id;
            payload.varValues = getNestedValuesObj(this.inputModel);
            this.$store.commit("rules/testedRules", null);
            this.$store.dispatch("rules/testRule", payload);
        },
        copyToClipboard() {
            const el = document.createElement("textarea");
            el.value = JSON.stringify(this.inputModel);
            el.setAttribute("readonly", "");
            el.style = { position: "absolute", left: "-9999px" };
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        },
        pasteClipboard() {
            navigator.clipboard.readText().then(copyObject => {
                this.copyOfInputModel = copyObject;
                try {
                    this.copyOfInputModel = JSON.parse(this.copyOfInputModel);
                } catch (e) {
                    console.error(e);
                }
                let matchedKeys = 0;
                Object.keys(this.copyOfInputModel).forEach(key => {
                    if (
                        this.conditionsObj.hasOwnProperty(key)
                        && this.copyOfInputModel[key] !== ""
                    ) {
                        this.inputModel[key] = this.copyOfInputModel[key];
                        matchedKeys += 1;
                        this.setInputValue(
                            this.copyOfInputModel[key],
                            key,
                            this.conditionsObj[key]
                        );
                    }
                });
                this.conditionsObj = { ...this.conditionsObj };
                if (matchedKeys >= 1) {
                    document
                        .getElementById("pasteBtn")
                        .classList.remove("q-focusable");
                    this.$toast.showNotify({
                        type: "success",
                        message: matchedKeys + this.$t("diagrams.components.ruleTesting.successPaste")
                    });
                } else {
                    document
                        .getElementById("pasteBtn")
                        .classList.remove("q-focusable");
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("diagrams.components.ruleTesting.noMatchPaste")
                    });
                }
            });
        }
    }

};
